<template>
  <div
    class="alert alert-danger alert-dismissible fade show"
    v-if="!this.coupon.isValid && this.coupon.message"
    role="alert"
  >
    {{ this.coupon.message }}
  </div>
  <div class="alert alert-success alert-dismissible fade show" v-if="this.coupon.isValid" role="alert">
    <strong>{{ this.coupon.code }}</strong> has been applied.
  </div>
</template>
<script>
export default {
  name: 'CheckoutCouponNotification',
  props: ['coupon']
};
</script>



